import React from "react";
import "./ProfileStyle.sass"
import ProfileAboutMe from "./Profile_aboutMe/ProfileAboutMe";
import ProfilePosts from "./Profile_posts/ProfilePosts";
import Preloader from "../../Utilits/Preloader/Preloader";

const Profile = (props) => {
    if (!props.profile)
        return <Preloader/>;
    return (
        <div className={'main-bg profile'}>
            <div className="profile__container container">
                <ProfileAboutMe profile={props.profile}
                                status={props.status}
                                putStatus={props.putStatus}
                                putProfile={props.putProfile}
                                setImageProfile={props.setImageProfile}
                                isOwner={props.isOwner}
                                follow={props.follow}
                                unFollow={props.unFollow}
                                activeUserFollowed={props.activeUserFollowed}
                                waitingSubscripe={props.waitingSubscripe}
                />
                <ProfilePosts posts={props.posts}
                              myPhotos={props.profile.photos.small}
                              name={props.profile.fullName}
                              addPost={props.addPost}/>
            </div>
        </div>
    )
};



export default Profile